/*
 * @Author: chenhui@didichuxing.com
 * @Date: 2018-12-17
 * @Description:  x推c落地页被推荐人页
 */
<template>
  <div class="xtc-container">
    <div class="xtc-container-main">
      <!-- banner start -->
      <div class="banner">
        <template v-if="(this.hasPoi || this.configInfo) && !allFalse">
          <rich-slide ref="slide" :data="focusImg">
            <rich-slide-item v-for="(item, index) in focusImg" :key="index" @click.native="clickHandler(item, index)">
              <div class="slide-item">
                <span class="mainTitle">{{item.title}}</span>
                <span class="subTitle">{{item.subTitle}}</span>
                <img :src="item.url">
              </div>
            </rich-slide-item>
            <template slot="dots" slot-scope="props">
              <span class="my-dot" v-if="props.dots.length > 1" :class="{active: props.current === index}" v-for="(item, index) in props.dots">{{index + 1}}</span>
              <span class="my-dot" v-else style="display:none"></span>
            </template>
          </rich-slide>
        </template>
        <!-- 接口拉取失败 -->
        <template v-if="beforeHasPoi || allFalse">
          <div class="errStatus" :style="{'background-image': bannerBg}"></div>
        </template>
      </div>
      <!-- banner end -->

      <!-- 兑换码模板 start -->
      <div class="code-box" v-if="configInfo && configInfo.sharePage && +configInfo.sharePage.type === 2">
        <!-- 领取提示文案 -->
        <div class="line-info">
          <img :src="configInfo.headImg" class="headImg" width="80" height="80" v-if="configInfo.headImg" />
          <img src="../../../assets/images/xtc/headimg@2x.png" width="80" height="80" class="headImg" v-else />
          <div class="line-wrap-bk">{{configInfo.sharePage.text}}</div>
        </div>
        <!-- 复制兑换码 -->
        <div class="redeem">
          <rich-input v-model="redeemValue" ></rich-input>
          <span
            v-if="clipboard"
            class="copy-btn"
            :data-clipboard-text="redeemValue"
            @click="copyRedeemValue"
          >
          {{gettext('复制')}}
          </span>
          <rich-button
            @click="toAppExchange"
          >
            {{configInfo.sharePage.btnText}}
          </rich-button>
        </div>
      </div>
      <!-- 兑换码模板 end -->

      <!-- 手机号模板 start -->
      <div class="code-box" v-else-if="configInfo && configInfo.sharePage && +configInfo.sharePage.type === 1">
        <!-- 领取前 -->
        <div class="line-info" v-if="!redeemStatus">
          <img :src="configInfo.headImg" class="headImg" width="80" height="80" v-if="configInfo.headImg" />
          <img src="../../../assets/images/xtc/headimg@2x.png" width="80" height="80" class="headImg" v-else />
          <div class="line-wrap-bk">{{configInfo.sharePage.text}}</div>
        </div>
        <!-- 领取成功后 -->
        <div class="line-info" v-if="redeemStatus && !couponFalse">
          <div class="line-wrap-bk"><span class="couponSuccess"></span><strong>{{gettext('领取成功')}}</strong></div>
          <div class="line-wrap-bk line-phone-bk">{{gettext('优惠券已放入')}}: {{countryCode}} {{phoneValue}}</div>
          <!-- <div class="btnBd"> -->
            <rich-button
              class="btnFixed"
              @click="toAppUse"
            >
              {{configInfo.sharePage.resultPage.btnText}}
            </rich-button>
          <!-- </div> -->
        </div>
        <!-- 领取失败后 -->
        <div class="line-info" v-else-if="redeemStatus && couponFalse">
          <!-- <div class="line-wrap-bk"><strong>{{gettext('领取不成功')}}</strong></div> -->
          <div class="line-wrap-bk" v-if="couponError"><span class="couponError"></span><strong>{{couponError}}</strong></div>
          <rich-button
            class="btnFixed"
            @click="resultLink"
          >
            {{configInfo.sharePage.resultPage.btnText}}
          </rich-button>
        </div>
        <!-- 手机号填写 -->
        <div class="redeem" v-if="!redeemStatus">
          <validate-tel
            :value="tel"
            :buttonText="configInfo.sharePage.btnText"
            :errorMessage="msg"
            :btnLoading="btnLoading"
            @confirm="confirm"></validate-tel>
        </div>
        <!-- 领取成功后券列表 -->
        <scroll-coupon-list
          v-if="this.couponData && this.couponData.couponList"
          class="coupon-list"
          :couponData="couponData"
          :couponCurrency="configInfo.sharePage.rewardInfo.currency">
        </scroll-coupon-list>
      </div>
      <!-- 手机号模板 end -->

      <!-- 接口拉取失败 -->
      <div class="code-box" v-if="!beforeHasPoi && allFalse">
        <div class="line-info">
          <div class="line-wrap-bk" v-if="actStatus"><strong>{{gettext('活动已结束')}}</strong></div>
          <div class="line-wrap-bk" v-else><strong>{{gettext('当前无有效活动')}}</strong></div>
        </div>
        <rich-button
          class="btnFixed"
          @click="resultLink"
        >
          {{gettext('去看看其他的')}}
        </rich-button>
      </div>
    </div>
    <loading-mask v-show="loading"></loading-mask>
  </div>

</template>

<script>
import Clipboard from 'clipboard'
import { debounce } from '@/common/js/utils'
import { mapGetters, mapActions } from 'vuex'
import trackEvent from '@/common/js/track'
import { setTitle } from '@/common/js/bridge'
import ScrollCouponList from './modules/scroll-coupon-list'
import ValidateTel from '@/components/telValidate/index'
import LoadingMask from '@/components/loading/loading-mask'
import getCountryConfig from '@/common/config/country-config'
import PerformanceTool from '@didi/soda-fe-performance-tool'

export default {
  name: 'participate',
  data () {
    return {
      tel: '',
      msg: '',
      beforeHasPoi: true,
      hasPoi: false,
      poiLat: 0,
      poiLng: 0,
      focusImg: [],
      redeemValue: '',
      phoneValue: '',
      countryCode: '',
      configInfo: null,
      couponData: {},
      couponError: '',
      couponFalse: false,
      redeemStatus: false,
      allFalse: false,
      actStatus: 0,
      loading: true,
      btnLoading: false,
      globalParams: {}
    }
  },
  components: {
    ScrollCouponList,
    ValidateTel,
    LoadingMask
  },
  computed: {
    ...mapGetters({
      participateInfo: 'participateInfo'
    }),
    country () {
      return this.$store.state.country
    },
    brand () {
      return this.$store.state.brand
    },
    // 根据不同国家展示不同优惠券背景占位图
    bannerBg () {
      return `url(${getCountryConfig.bannerBgConfig.COUPON_BG(this.country)['C_BANNER_BG']})`
    }
  },
  methods: {
    ...mapActions({
      getParticipateInfo: 'getParticipateInfo',
      getParticipateRedeem: 'getParticipateRedeem'
    }),
    confirm (value, isAgree) {
      this.countryCode = value.code
      this.phoneValue = value.number
      this.msg = ''
      this.isAgree = isAgree
      this.getCoupon()
    },
    initClipBoard () {
      // TODO: 不支持clipboard兼容
      if (Clipboard.isSupported()) {
        this.clipboard = new Clipboard('.copy-btn')
      }
    },
    async getCoupon () {
      // this.loadingToast = this.$createToast({
      //   mash: true,
      //   txt: this.gettext('正在加载...')
      // })
      // this.loadingToast.show()
      this.loading = true
      this.btnLoading = true
      let res = await this.getParticipateRedeem({
        phone: this.phoneValue,
        activityId: this.params.activityId,
        countryCode: this.countryCode,
        code: this.params.code,
        poiLat: this.poiLat || this.params.poiLat || 0,
        poiLng: this.poiLng || this.params.poiLng || 0,
        isAgree: this.isAgree, // 用户是否同意注册协议
        osType: this.globalParams.osType ? this.globalParams.osType : 3 // 获取端类型。若公餐获取不到则认为是在浏览器打开。osType为3
      })
      this.loading = false
      this.btnLoading = false
      if (res && res.errno === 0 && res.data) {
        if (!PerformanceTool.isReported) {
          setTimeout(() => {
            trackEvent({
              eventId: 'sailing_act_x_participate_home_load_timing',
              eventLabel: '被推荐人页面展示',
              attrs: {
                ...PerformanceTool.getPerformanceCommonParams()
              }
            })
            trackEvent({
              eventId: 'sailing_act_x_landingpage_static_resource_load_timing',
              eventLabel: '被推荐人页面静态资源',
              attrs: {
                ...PerformanceTool.getStaticResourceDownloadParams()
              }
            })
          })
        }
        this.couponData = res.data
        this.redeemStatus = true
        if (this.configInfo.sharePage.resultPage.title) {
          setTitle(this.configInfo.sharePage.resultPage.title)
        }
        this.focusImg = this.configInfo.sharePage.resultPage.focusImg.list
        trackEvent({
          eventId: 'sailing_c_x_invitereceive_accept_ck',
          eventLabel: '推荐有奖页面点击领取',
          attrs: {
            invite_code: this.params.code || '',
            channel_id: this.params.channel_id || '',
            activity_id: this.params.activityId || '',
            page_type: this.configInfo.sharePage.type || '',
            content: this.phoneValue || '',
            is_suc: 1,
            failure_reason: '',
            poiLat: this.poiLat,
            poiLng: this.poiLng,
            city_id: this.configInfo.cityId
          }
        })
      } else if (res && +res.errno === 13012) {
        const toast = this.$createToast({
          time: 1000,
          txt: res.errmsg,
          type: 'error'
        })
        toast.show()
      } else {
        this.couponFalse = true
        this.couponError = res.errmsg
        this.redeemStatus = true
        trackEvent({
          eventId: 'sailing_c_x_invitereceive_accept_ck',
          eventLabel: '推荐有奖页面点击领取',
          attrs: {
            invite_code: this.params.code || '',
            channel_id: this.params.channel_id || '',
            activity_id: this.params.activityId || '',
            page_type: this.configInfo.sharePage.type || '',
            content: this.phoneValue || '',
            is_suc: 0,
            failure_reason: res.errmsg,
            poiLat: this.poiLat,
            poiLng: this.poiLng
          }
        })
      }
    },
    copyRedeemValue: debounce(function () {
      let _this = this
      this.clipboard.on('success', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: _this.gettext('复制成功'),
          type: 'correct'
        })
        toast.show()
        e.clearSelection()
        trackEvent({
          eventId: 'sailing_c_x_invitereceive_copy_ck',
          eventLabel: '推荐有奖页面优惠码复制按钮点击',
          attrs: {
            invite_code: this.params.code || '',
            channel_id: this.params.channel_id || '',
            activity_id: this.params.activityId || '',
            poiLat: this.poiLat,
            poiLng: this.poiLng,
            city_id: this.configInfo.cityId
          }
        })
        trackEvent({
          eventId: 'sailing_c_x_invitereceive_accept_ck',
          eventLabel: '推荐有奖页面点击领取',
          attrs: {
            invite_code: this.params.code || '',
            channel_id: this.params.channel_id || '',
            activity_id: this.params.activityId || '',
            page_type: this.configInfo.sharePage.type || '',
            content: this.params.coupon_code || '',
            is_suc: 0,
            failure_reason: '',
            poiLat: this.poiLat,
            poiLng: this.poiLng,
            city_id: this.configInfo.cityId
          }
        })
      })
      this.clipboard.on('error', e => {
        const toast = this.$createToast({
          time: 1000,
          txt: _this.gettext('该浏览器不支持自动复制'),
          type: 'error'
        })
        toast.show()
        e.clearSelection()
      })
    }, 200),
    clickHandler (item, index) {
    },
    async resultLink () {
      await this.gotoDeeplinkTrack()
      window.location.href = this.getAppLinkHome()
    },
    async toAppUse () {
      await this.gotoAppUseTrack()
      window.location.href = this.getAppLinkHome()
    },
    async toAppExchange () {
      let urlScheme = `${this.getAppLinkCode()}?code=${this.params.code}&activityType=1`
      await this.gotoAppLinkTrack()
      window.location.href = urlScheme
    },
    // 输入手机号码兑换成功之后点击立即使用
    async gotoAppUseTrack () {
      let trackAttrs = {
        eventId: 'sailing_c_x_invitereceive_use_ck',
        eventLabel: '推荐有奖页面输入手机号码兑换成功之后点击立即使用',
        attrs: {
          invite_code: this.params.code || '',
          channel_id: this.params.channel_id || '',
          activity_id: this.params.activityId || '',
          poiLat: this.poiLat,
          poiLng: this.poiLng,
          city_id: this.configInfo.cityId
        }
      }
      let timer = new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, 1500)
      })
      await Promise.race([trackEvent(trackAttrs), timer])
      return true
    },
    // 打开applink的埋点
    async gotoAppLinkTrack () {
      let trackAttrs = {
        eventId: 'sailing_c_x_cgc_to_applink_button_ck',
        eventLabel: '被推荐页面applink链接跳转',
        attrs: {
          invite_code: this.params.code || '',
          channel_id: this.params.channel_id || '',
          activity_id: this.params.activityId || '',
          page_type: (this.configInfo && this.configInfo.sharePage.type) || '',
          country: this.country,
          poiLat: this.poiLat,
          poiLng: this.poiLng,
          city_id: this.configInfo.cityId
        }
      }
      let timer = new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, 1500)
      })
      await Promise.race([trackEvent(trackAttrs), timer])
      return true
    },
    // 打开deeplink的埋点
    async gotoDeeplinkTrack () {
      let trackAttrs = {
        eventId: 'sailing_c_x_cgc_to_deeplink_button_ck',
        eventLabel: '被推荐页面deeplink中间页“button”点击',
        attrs: {
          invite_code: this.params.code || '',
          channel_id: this.params.channel_id || '',
          activity_id: this.params.activityId || '',
          page_type: (this.configInfo && this.configInfo.sharePage.type) || '',
          country: this.country,
          poiLat: this.poiLat,
          poiLng: this.poiLng,
          city_id: (this.configInfo && this.configInfo.cityId) || ''
        }
      }
      let timer = new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, 1500)
      })
      await Promise.race([trackEvent(trackAttrs), timer])
      return true
    },
    getDeepLink () {
      return getCountryConfig.deepLinkUrl.DEEPLINKURL(this.country)
    },
    getAppLinkCode () {
      return getCountryConfig.appLinkUrl.APPLINKURL_CODE(this.brand)
    },
    getAppLinkHome () {
      return getCountryConfig.appLinkUrl.APPLINKURL_HOME(this.brand)
    },
    async fetchParticipateInfo (data) {
      this.poiLat = data.lat
      this.poiLng = data.lng
      // let res = await this.getParticipateInfo({activityId: this.params.activityId, activityType: this.params.activityType, code: this.params.code, poiLat: 20.627293, poiLng: -103.3236756})
      let res = await this.getParticipateInfo({activityId: this.params.activityId, activityType: this.params.activityType, code: this.params.code, poiLat: this.poiLat || this.params.poiLat || 0, poiLng: this.poiLng || this.params.poiLng || 0})
      this.loading = false
      if (res && (res.errno === 0) && res.data) {
        // this.loadingToast.hide()
        this.initClipBoard()
        this.configInfo = res.data
        this.focusImg = res.data.sharePage.focusImg.list
        if (this.configInfo.sharePage.title) {
          setTitle(this.configInfo.sharePage.title)
        }
        trackEvent({
          eventId: 'sailing_c_x_invitereceive_common_sw',
          eventLabel: '推荐有奖领取页面展示',
          attrs: {
            invite_code: this.params.code || '',
            channel_id: this.params.channel_id || '',
            activity_id: this.params.activityId || '',
            page_type: this.configInfo.sharePage.type || '',
            status: 1,
            city_id: this.configInfo.cityId,
            poiLat: this.poiLat,
            poiLng: this.poiLng
          }
        })
      } else if (res && (res.errno === 13002)) {
        this.allFalse = true
        this.actStatus = 1
        this.beforeHasPoi = false
        trackEvent({
          eventId: 'sailing_c_x_invitereceive_common_sw',
          eventLabel: '推荐有奖领取页面展示',
          attrs: {
            invite_code: this.params.code || '',
            channel_id: this.params.channel_id || '',
            activity_id: this.params.activityId || '',
            page_type: '',
            status: 3,
            poiLat: this.poiLat,
            poiLng: this.poiLng
          }
        })
      } else {
        this.allFalse = true
        this.beforeHasPoi = false
        trackEvent({
          eventId: 'sailing_c_x_invitereceive_common_sw',
          eventLabel: '推荐有奖领取页面展示',
          attrs: {
            invite_code: this.params.code || '',
            channel_id: this.params.channel_id || '',
            activity_id: this.params.activityId || '',
            page_type: '',
            status: 3,
            poiLat: this.poiLat,
            poiLng: this.poiLng
          }
        })
      }
    }
  },
  async created () {
    setTitle(this.gettext('推荐有奖'))
    // this.loadingToast = this.$createToast({
    //   mash: true,
    //   txt: this.gettext('正在加载...')
    // })
    // this.loadingToast.show()
    this.redeemValue = this.params.code || ''
    let _this = this
    const globalParams = await this.SodaBridge('getGlobalParams', 'badcase') || {}
    this.globalParams = (globalParams && globalParams.data) || {}
    try {
      window.Soda.getLocationInfo({}, function (data) {
        if (data && +data.errno === 1) {
          // _this.loadingToast.hide()
          _this.loading = false
          // _this.$createDialog({
          //   type: 'alert',
          //   icon: 'richic-important',
          //   title: _this.gettext('请开启定位'),
          //   content: _this.gettext('定位服务未开启，需要先开启定位服务才能参与活动！'),
          //   showClose: true,
          //   confirmBtn: {
          //     text: _this.gettext('我知道了'),
          //     active: true,
          //     disabled: false,
          //     href: 'javascript:;'
          //   }
          // }).show()
          trackEvent({
            eventId: 'sailing_c_x_invitereceive_locateopen_ck',
            eventLabel: '推荐有奖页面请开启定位点击开启定位按钮',
            attrs: {
              invite_code: _this.params.code || '',
              channel_id: _this.params.channel_id || '',
              activity_id: _this.params.activityId || '',
              page_type: ''
            }
          })
          _this.hasPoi = false
          // _this.allFalse = true
          _this.beforeHasPoi = false
          // status=2 代表未开启定位？
          trackEvent({
            eventId: 'sailing_c_x_invitereceive_common_sw',
            eventLabel: '推荐有奖领取页面展示',
            attrs: {
              invite_code: _this.params.code || '',
              channel_id: _this.params.channel_id || '',
              activity_id: _this.params.activityId || '',
              page_type: '',
              status: 2
            }
          })
          _this.fetchParticipateInfo(data)
        } else {
          _this.hasPoi = true
          _this.fetchParticipateInfo(data)
        }
      })
    } catch (e) {
      console.log('geoerror')
      this.hasPoi = false
      this.allFalse = true
      this.beforeHasPoi = false
    }
  },
  beforeDestroy () {
    this.clipboard && this.clipboard.destroy()
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/var";
.xtc-container {
  position: relative;
  background: #fff;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .rich-dialog-title{
    .rich-dialog-title-def {
      font-size: 32px;
      color: #333;
    }
  }
  .btnFixed {
    width: 90%;
    padding: 0;
    position: fixed;
    left: 0;
    bottom: 36px;
    z-index: 1;
  }
  @media screen and (min-width : 1024px) {
    .btnFixed{
      position: static;
    }
  }
  &-main {
    margin: 0 0 104px 0;
    .btnBd {
      padding: 36px 0;
      background: #fff;
    }
    .rich-btn {
      margin: 40px 36px 0;
      height: 92px;
      z-index: 99;
      &:active:after{
        border: none;
      }
    }
    .slide-item {
      position: relative;
      .mainTitle {
        display: none;
        position: absolute;
        left: 10px;
        bottom: 50px;
      }
      .subTitle {
        display: none;
        position: absolute;
        left: 10px;
        bottom: 10px;
        font-size: 28px;
      }
      img {
        width: 100%;
        height: 430px;
      }
    }
    .banner {
      overflow: hidden;
      width: 100%;
      height: 430px;
      background-color: #f5f5f5;
      .errStatus {
        overflow: hidden;
        width: 100%;
        height: 430px;
        text-align: center;
        background-size: 100%;
        strong{
          margin: 200px auto 0;
          display: block;
          font-weight: normal;
        }
      }
    }
    .detail-rules {
      color: #4A4A4A;
      font-size: 32px;
      margin-top: 37px;
      text-align: center;
      .richic-arrow {
        color:#999999;
        font-size: 24px;
        margin-left: 6px;
      }
    }
    .rich-input:after {
      border: none;
    }
    .code-box {
      margin: 54px 36px 0;
      text-align: center;
      .headImg {
        border: 0;
        max-width: none;
        object-fit: cover;
        border-radius: 160px;
      }
      .redeem {
        position: relative;
        margin-top: 60px;
        .rich-btn {
          margin: 0;
        }
        .rich-input {
          height: 90px;
          padding: 12px;
          margin-bottom: 60px;
          border-bottom: 1px rgba(0,0,0,0.10) solid;
          font-family: 'Aspira-Demi';
          font-size: 48px;
          font-weight: bold;
        }
        .copy-btn {
          position: absolute;
          top: 46px;
          right: 66px;
          width: 40px;
          height: 40px;
          line-height: 40px;
          padding-left: 46px;
          white-space: nowrap;
          @include copy-icon();
          margin-left: 17px;
          box-sizing: border-box;
          font-size: 28px;
          color: #ff7a45;
        }
      }
      .rich-input-field {
        font-size: 48px;
      }
      .line-info {
        img {
          width: 100px;
          height: 100px;
          overflow: hidden;
          display: block;
          margin: 54px auto 20px;
        }
        .line-wrap-bk {
          margin: 0 95px 60px;
          line-height: 38px;
          font-size: 32px;
          text-align: center;
          strong {
            display: block;
            margin: 20px auto;
            font-weight: normal;
          }
          .couponError {
            display: block;
            margin: 0 auto;
            width: 100px;
            height: 100px;
            @include coupon-get-error();
          }
          .couponSuccess {
            display: block;
            margin: 0 auto;
            width: 100px;
            height: 100px;
            @include coupon-get-success()
          }
        }
        .line-phone-bk {
          margin: 0 25px 60px;
          white-space: nowrap;
        }
      }
      .line-wrap {
        display: flex;
        justify-content: center;
        .line {
          display: block;
          width: 146px;
          height: 2px;
          margin-top: 14px;
          &.r  {
            background: linear-gradient(to right, #D8D8D8 , #ffffff);
            margin-left: 24px;
          }
          &.l {
            background: linear-gradient(to right, #ffffff, #D8D8D8);
            margin-right: 24px;
          }
        }
        .text {
          color: #999999;
          display: block;
          font-size: 28px;
          margin-bottom: 48px;
        }
      }
      .copy-wrap {
        display: flex;
        justify-content: center;
        .copy-btn {
          width: 40px;
          height: 40px;
          @include copy-icon();
          margin-left: 17px;
          margin-top: 20px;
          box-sizing: border-box;
        }
        .code {
          font-size: 48px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          line-height: 33px;
          font-weight: bold;
          -webkit-user-select: text;
        }
      }

    }
    .share-box {
      margin-top: 55px;
      .title {
        font-size: 28px;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
        margin-bottom: 39px;
      }
    }
  }
  &-footer {
    box-sizing: border-box;
    height: 244px;
    width: 100%;
    background: #F7F8FA;
    padding: 39px 0;
  }
}
</style>
